// Pure helpers for rendering post dates and truncating post previews in the
// channels timeline. Kept free of React/Ionic so they stay unit-testable.
import { formatDateHeader } from '../../../fantasy-leagues-tabs/utils/dateGrouping';

export const POST_PREVIEW_LENGTH = 160;

// Render a post's date/time in Spanish. Today shows the hour only ("14:30"),
// older days keep a day prefix ("Ayer 09:15", "12 ago 18:40").
export const formatPostDateTime = (iso: string): string => {
  const date = new Date(iso);
  const hour = date.toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Madrid',
  });

  const dayHeader = formatDateHeader(iso);
  if (dayHeader === 'Hoy') {
    return hour;
  }

  // Use a compact day label for older dates (e.g. "12 ago").
  const dayLabel =
    dayHeader === 'Ayer'
      ? 'Ayer'
      : new Date(date.toLocaleString('en-US', { timeZone: 'Europe/Madrid' })).toLocaleDateString(
          'es-ES',
          {
            day: 'numeric',
            month: 'short',
            timeZone: 'Europe/Madrid',
          }
        );

  return `${dayLabel} ${hour}`;
};

export interface TruncatedText {
  preview: string;
  isTruncated: boolean;
}

// Truncate `text` to at most `max` characters, cutting at a word boundary and
// appending an ellipsis when the text was actually shortened.
export const truncatePostText = (text: string, max = POST_PREVIEW_LENGTH): TruncatedText => {
  const trimmed = text.trim();
  if (trimmed.length <= max) {
    return { preview: trimmed, isTruncated: false };
  }

  const slice = trimmed.slice(0, max);
  const lastSpace = slice.lastIndexOf(' ');
  const cut = lastSpace > 0 ? slice.slice(0, lastSpace) : slice;

  return { preview: `${cut.trimEnd()}…`, isTruncated: true };
};
